<template>
  <doll-selector :last-lang="$route.params.lastLang">
  </doll-selector>
</template>

<script>
import DollSelector from '../components/DollSelector.vue'

  export default {
    name: 'Home',

    components: {
        DollSelector,
    },
  }
</script>
